import { render, staticRenderFns } from "./refresh_web_design.vue?vue&type=template&id=8285b792&scoped=true&lang=pug&"
import script from "./refresh_web_design.vue?vue&type=script&lang=js&"
export * from "./refresh_web_design.vue?vue&type=script&lang=js&"
import style0 from "./refresh_web_design.vue?vue&type=style&index=0&id=8285b792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8285b792",
  null
  
)

export default component.exports